import React from "react";
import Slider from "react-slick";
import {
  Box,
  Grid,
  Typography,
  Button,
  Avatar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  ArrowForwardIos,
  ArrowBackIos,
  Grain,
  LocationOn,
  DesignServices,
  Security,
} from "@mui/icons-material";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Images
import redonionbanner from './images/onion-banner.png';
import webdesign from './images/webdesign.jpg'
import webdevelopment from './images/webdev.png'
import logodesign from './images/logo desgin.jpg'
import digitalmarketing from './images/digitalmarketing.jpg'
import pinkOnionFlakeImage from './images/Dehydrated Onion Flakes Supplier, Exporter _ Dehydratedveg_com.jpeg'
import garlicCloveImage from './images/GarlicClove.jpg'
import garlicChoppedImage from './images/GarlicMinced.jpeg'
import garlicMincedImage from './images/how-to-mince-garlic-2171-1.jpg'
import garlicGranulesImage from './images/GarlicGranules.jpg'
import pinkOnionGranulesImage from './images/PinkOnionGranules.webp'
import pinkOnionChoppedImage from './images/purple-onion-cut-half-pink-strips-visible-against-dark-background-344354882.webp'
import pinkOnionMincedImage from './images/pinkonionminced.jpg'
import pinkOnionPowderImage from './images/pinkonionpowder.jpg'
import whiteOnionFlakeImage from './images/whiteonionflakes.webp'
import whiteOnionGranulesImage from './images/whiteoniongranules.jpeg'
import whiteOnionChoppedImage from './images/dehydrated-white-onion-chopped-500x500.webp'
import whiteOnionMincedImage from './images/dehydrated-white-onion-minced-500x500.webp'
import whiteOnionPowderImage from './images/dehydrated-white-onion-powder.jpg'
import redOnionFlakeImage from './images/redonionflakes.webp'
import redOnionGranulesImage from './images/dehydrated-red-onion-granules-0-2-1-mm.jpg'
import redOnionChoppedImage from './images/red-onion-chopped-2-scaled-500x500.webp'
import redOnionMincedImage from './images/dehydrated-red-onion-minced-500x500.webp'
import redOnionPowderImage from './images/redonionpowder.jpg'
import friedOnionFreshImage from './images/organic-onion-fried-500x500.webp'
import friedCoatedWhiteOnionImage from './images/whitecoatedonion.webp'
import friedCoatedPinkOnionImage from './images/pink-coated-fried-onion.jpg'
import friedWhiteOnionFlakeImage from './images/friedcoatedmin.jpg'
import friedPinkOnionFlakeImage from './images/friedcoatedmin.jpg'
import gingerFlakeImage from './images/dehydrated-ginger-flakes.jpg'
import gingerPowderImage from './images/113563735.webp'
import greenChilliPowderImage from './images/dehydrated-green-chilli-powder-500x500.webp'
import tamarindPowderImage from './images/tamarind-powder-500x500.webp'
import tomatoPowderImage from './images/toamatopowder.jpg'
import mintPowderImage from './images/mint-leaves-pudina-patta-powder-2nd.jpeg'
import potatoPowderImage from './images/istockphoto-185902790-612x612.jpg'
import spinachPowderImage from './images/spinachpowder.jpg'
import mangoPowderImage from './images/AmchurPowder.webp'
import fenugreekPowderImage from './images/7d59b4210bfcc07bb28cdba3eae734816bdc8e06_1024x1024.webp'
import lemonPowderImage from './images/07_Spray-Dried-Lemon-Powder-600x600.jpg'
import beetrootPowderImage from './images/DriedBeetrootPowder.webp'
import cheesePowderImage from './images/IMG_6946_800x.webp'
import corianderPowderImage from './images/CorianderPowder.webp'
import beetrootImage from './images/istockphoto-493446908-612x612.jpg'
import cabbageImage from './images/istockphoto-544313316-612x612.jpg'
import carrotImage from './images/carrots.jpg'
import tomatoImage from './images/istockphoto-98026003-612x612.jpg'
import gingerImage from './images/istockphoto-162711007-612x612.jpg'
import potatoImage from './images/istockphoto-1346299887-612x612.jpg'
import greenChilliImage  from './images/green-chilli-200-g-product-images-o590000187-p590000187-0-202409251830.webp'

// Components
import Commonredirects from "./Commonredirects";
import FeatureProduct from "./FeatureProduct";

// Theme Colors
const primaryColor = "#1F473E";
const secondaryColor = "#D4C9B6";

// Animation
const floatAnimation = {
  animate: {
    y: [0, -10, 0],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};

// Custom Arrows
const NextArrow = ({ onClick }) => (
  <ArrowForwardIos
    onClick={onClick}
    sx={{
      position: "absolute",
      top: "50%",
      right: "15px",
      zIndex: 10,
      cursor: "pointer",
      fontSize: 40,
      color: secondaryColor,
      background: primaryColor,
      borderRadius: "50%",
      padding: "5px",
      transition: "0.3s",
      "&:hover": {
        transform: "scale(1.2)",
        background: secondaryColor,
        color: primaryColor,
      },
    }}
  />
);

const PrevArrow = ({ onClick }) => (
  <ArrowBackIos
    onClick={onClick}
    sx={{
      position: "absolute",
      top: "50%",
      left: "15px",
      zIndex: 10,
      cursor: "pointer",
      fontSize: 40,
      color: secondaryColor,
      background: primaryColor,
      borderRadius: "50%",
      padding: "5px",
      transition: "0.3s",
      "&:hover": {
        transform: "scale(1.2)",
        background: secondaryColor,
        color: primaryColor,
      },
    }}
  />
);

const DetailedProductRedOnions = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const slides = [
    {
      image: redonionbanner,
      title: "Dehydrated Red Onions",
      description:
        "Experience the rich flavor and aroma of our premium organic Red onions, sourced from the finest farms.",
      buttonText: "Order Now",
    },
  ];
const redOnionFlake = {
  image: redOnionFlakeImage,
  features: [
    {
      icon: Grain,
      title: "Red Onion Flakes",
      description:
        "Dehydrated red onion flakes with a strong aroma and vibrant color. Perfect for enhancing taste and texture.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Form: Flakes. Color: Natural red-purple. Purity: 100%. Packaging: Food-grade bags. Shelf Life: 12 months.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Prepared from premium red onions, sliced and dehydrated to preserve natural flavor and nutrients. Ideal for toppings, seasoning, and dry food mixes.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Adds bold flavor and visual appeal to dishes. Convenient for bulk use, easy to store and rehydrate.",
    },
  ],
};

const redOnionGranules = {
  image: redOnionGranulesImage,
  features: [
    {
      icon: Grain,
      title: "Red Onion Granules (0.5–1 mm)",
      description:
        "Granulated red onions for easy mixing and uniform seasoning in food products.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Particle Size: 0.5–1 mm. Color: Natural red. Purity: 100%. Packaging: Food-grade bags. Shelf Life: 12 months.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Made from high-quality red onions, granulated after dehydration to retain strong flavor and aroma. Ideal for spice blends and dry soups.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Perfect for commercial food production and home cooking. Easy to store, blend, and portion.",
    },
  ],
};

const redOnionChopped = {
  image: redOnionChoppedImage,
  features: [
    {
      icon: Grain,
      title: "Red Onion Chopped (3–5 mm)",
      description:
        "Chopped red onions that retain color, flavor, and texture. Suitable for various food applications.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Form: Chopped. Size: 3–5 mm. Color: Natural red. Purity: 100%. Packaging: Food-grade bags. Shelf Life: 12 months.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Sourced from fresh red onions, chopped and dehydrated for long shelf life. Great for ready-to-eat meals and instant mixes.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Maintains original aroma and bite. Easy to rehydrate and cook. Used in snacks, sauces, and gravies.",
    },
  ],
};

const redOnionMinced = {
  image: redOnionMincedImage,
  features: [
    {
      icon: Grain,
      title: "Red Onion Minced (1–3 mm)",
      description:
        "Finely minced red onions ideal for uniform flavor distribution and convenience.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Particle Size: 1–3 mm. Color: Deep red. Purity: 100%. Packaging: Food-grade bags. Shelf Life: 12 months.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Dehydrated minced red onions prepared for easy use in seasonings, dry curry bases, and ready-to-cook products.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Perfect for instant foods and spice manufacturers. Ensures flavor consistency across dishes.",
    },
  ],
};

const redOnionPowder = {
  image: redOnionPowderImage,
  features: [
    {
      icon: Grain,
      title: "Red Onion Powder",
      description:
        "Fine red onion powder packed with robust flavor. Ideal for spice blends and dry rubs.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Form: Fine powder. Color: Light red. Mesh Size: 80–100. Purity: 100%. Packaging: Food-grade pouches. Shelf Life: 12 months.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Carefully processed from dehydrated red onions, ground to a fine powder while preserving natural essence.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Great for seasoning, flavoring, and food manufacturing. Easy to blend, long-lasting, and space-efficient.",
    },
  ],
};



  return (
    <>
      {/* Hero Slider */}
      <Box sx={{ width: "100%", height: "90vh", overflow: "hidden", position: "relative" }}>
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <Box
              key={index}
              sx={{
                height: "90vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: `url(${slide.image}) center/cover no-repeat`,
                width: "100%",
              }}
            >
              <Box
                sx={{
                  background: "rgba(31, 71, 62, 0.3)",
                  color: secondaryColor,
                  padding: "20%",
                  borderRadius: "10px",
                  textAlign: "center",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                }}
              >
                <motion.div variants={floatAnimation} animate="animate">
                  <Typography variant="h2" sx={{ fontFamily: "'Playfair Display', serif", fontWeight: "bold", mb: 2 }}>
                    {slide.title}
                  </Typography>
                </motion.div>
                <motion.div variants={floatAnimation} animate="animate">
                  <Typography variant="h5" sx={{ fontFamily: "'Playfair Display', serif", mb: 3 }}>
                    {slide.description}
                  </Typography>
                </motion.div>
                <motion.div variants={floatAnimation} animate="animate">
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: secondaryColor, color: primaryColor, fontWeight: "bold" }}
                  >
                    {slide.buttonText}
                  </Button>
                </motion.div>
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>

      {/* Product Details Section */}
      <FeatureProduct data={redOnionGranules} title={"Dehydrated Red Onion Granules"} />
            <FeatureProduct data={redOnionFlake} title={"Dehydrated Red Onion Flakes"} />

      <FeatureProduct data={redOnionChopped} title={"Red Onion Chopped"} />

      <FeatureProduct data={redOnionMinced} title={"Red Onion Minced"} />

      <FeatureProduct data={redOnionPowder} title={"Red Onion Powder"} />

    

      <Commonredirects />
    </>
  );
};

export default DetailedProductRedOnions;
